export default __webpack_public_path__ + "static/media/factoryColoringSample.5d7f7e7db63d44f5ec3dd5ae0f413537.png";